import { Typography } from '@material-ui/core';
import styled from 'styled-components';
import { formatDate } from '@superdispatch/dates';
import { Stack, ColorDynamic } from '@superdispatch/ui';
import { LoadPaymentDTO } from '../data/LoadDTO';
import { ViewLoadLegNotes } from './ViewLoadLegNotes';
import { ViewLoadPaymentCardRow } from './ViewLoadPaymentRenderCardRow';

export const PaymentDetailsWithBorder = styled.div`
  border-left: 1px solid ${ColorDynamic.Silver500};
  margin-left: 7px;
  padding-left: 12px;
`;

interface InvoiceDetailsParams {
  payment?: LoadPaymentDTO | null;
  shouldShowSentDate?: boolean;
}
export function ViewInvoiceDetails({
  payment,
  shouldShowSentDate = true,
}: InvoiceDetailsParams) {
  return (
    <PaymentDetailsWithBorder>
      <Stack space="xsmall">
        {!!payment?.invoice?.invoice_id && (
          <ViewLoadPaymentCardRow
            title="Invoice #"
            value={payment.invoice.invoice_id}
          />
        )}
        {shouldShowSentDate && payment && (
          <ViewLoadPaymentCardRow
            title="Sent date"
            value={formatDate(payment.invoice.sent_at, {
              variant: 'DateTime',
            })}
          />
        )}
        {payment && !!payment.invoice?.invoice_notes && (
          <Stack>
            <Typography color="textSecondary">Notes</Typography>
            <ViewLoadLegNotes
              content={payment.invoice.invoice_notes}
              data-e2e="payment.invoice.invoice_notes"
            />
          </Stack>
        )}
      </Stack>
    </PaymentDetailsWithBorder>
  );
}
